import { guardEmptyString } from '@portal/utils/util-guards';
import { componentFactory } from 'vue-tsx-support';

import { JtnUiBaseBlock, JtnUiBtn } from '@jtnews/jtn-ui';
import { injectStylesMixin } from '@jtnews/shared';
import { Record as RecordData } from '@jtnews/shared/news';

import { AuthorRecordsItem } from './author-records-item';
import styles from './author-records.styles.scss?module';

export default componentFactory.mixin(injectStylesMixin(styles)).create({
  name: 'AuthorRecords',
  props: {
    items: {
      type: Array as () => RecordData[],
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    buttonLink: {
      type: String,
      default: ''
    }
  },
  render() {
    return (
      <JtnUiBaseBlock header={this.title} headerClass={styles.blockHeader}>
        {this.items.map(item => (
          <AuthorRecordsItem item={item} class={styles.item} />
        ))}
        {guardEmptyString(this.buttonLink) && (
          <JtnUiBtn class={styles.button} href={this.buttonLink} theme="lightGray">
            все статьи автора
          </JtnUiBtn>
        )}
      </JtnUiBaseBlock>
    );
  }
});
